"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaOn = exports.mediaMin = exports.mediaMax = void 0;

var _styledComponents = require("styled-components");

var _variables = require("./variables");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) and (max-width: ", "px) {\n        ", ";\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      @media (max-width: ", "px) {\n        ", ";\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var mediaMax = Object.keys(_variables.deviceSizes).reduce(function (argsAcc, label) {
  var acc = Object.assign({}, argsAcc);

  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject(), _variables.deviceSizes[label] - 1, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.mediaMax = mediaMax;
var mediaMin = Object.keys(_variables.deviceSizes).reduce(function (argsAcc, label) {
  var acc = Object.assign({}, argsAcc);

  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject2(), _variables.deviceSizes[label], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.mediaMin = mediaMin;
var mediaOn = Object.keys(_variables.deviceSizes).reduce(function (argsAcc, label, i) {
  var acc = Object.assign({}, argsAcc);
  var nextLabel = Object.keys(_variables.deviceSizes)[i + 1];

  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject3(), _variables.deviceSizes[nextLabel] || 0, _variables.deviceSizes[label] - 1, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.mediaOn = mediaOn;